module.exports = __webpack_public_path__ + "static/cloud-c5f6f3dd1242ba236d4ca0d4f0994cd2.png";